export const Service = {
  async login(payload: { email: string; password: string }) {
    const response = await fetch('/api/auth2/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    return { status: response.status, data };
  },
};
